module.exports = __webpack_public_path__ + "static/media/combo_ride_2.36c574d7.png";